import { render } from "./CrossSellResultsFTT.vue?vue&type=template&id=0f87fe89&scoped=true"
import script from "./CrossSellResultsFTT.vue?vue&type=script&lang=js"
export * from "./CrossSellResultsFTT.vue?vue&type=script&lang=js"

import "./CrossSellResultsFTT.vue?vue&type=style&index=0&id=0f87fe89&lang=scss"
import "./CrossSellResultsFTT.vue?vue&type=style&index=1&id=0f87fe89&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3487515193/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f87fe89"]])

export default __exports__